import get from 'lodash/get';

export const getFilters = state => state.form.adminCitiesFilters;

export const getModalData = modalName => state => get(state, `adminCities.modals.${modalName}.data`, {});

export const getCityById = id => state => {
    const cities = get(state, 'adminCities.data', []);
    return cities.find((a) => a.id === id);
};

export const isNewModal = modalName => state => {
    return get(state, `adminCities.modals.${modalName}.data.new`, false);
};
